import { environment } from "src/environments/environment";
import { errorHandler } from "src/app/util/errorHandler";
import { Router } from "@angular/router";
import { authData } from "src/app/util/auth";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ApiService } from "src/app/http/api.service";
import { OrderDTO, ShopItemsDTO } from "src/app/http/api-interface";
import { getImageUrl } from "src/app/util/helpers";

@Component({
  selector: "app-purchase-shop",
  templateUrl: "./purchase-shop.component.html",
})
export class PurchaseShopComponent implements OnInit, OnDestroy {
  constructor(
    public apiService: ApiService,
    private httpClient: HttpClient, private router: Router) {
    }

  downloader: any = null;

  payload: any = {};
  notification = {};

  fakeLoader = false;
  loading = false;
  dialog = false;
  showShopItemPopup = false;
  skeletonLoader = true;
  selectedShopItem!: ShopItemsDTO;
  shopItems: ShopItemsDTO[] = [];
  cart: OrderDTO = {};

  links: any[] = [];

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.shopItems = await this.apiService.getShopItems();
    this.loading = false;
    this.skeletonLoader = false;
    this.getLinks();
    this.getCart();
  }
  ngOnDestroy(): void {
    this.apiService.clearNotification();
  }

  async getCart() {
    this.cart = await this.apiService.getOrders();
  }

  getLinks() {
    this.links = this.shopItems.map(this.getLinkItems);
  }

  closePopup(event: any) {
    this.showShopItemPopup = false;
    this.getCart();
  }

  getLinkItems = (item: ShopItemsDTO) => {
    return {
      title: item.ShopItemID,
      icon: item.ImageData ? getImageUrl(item.ImageData) : "/assets/icons/shop-item.png",
      text: item.ShopItemName,
    }
  }

  showItemPopup(shopItmeID: string) {
    this.selectedShopItem = this.shopItems.find(x => x.ShopItemID == shopItmeID)!;
    if (this.selectedShopItem) {
      this.showShopItemPopup = true;
    }
  }

  filterItemLinks(event: any) {
    let searchText = event.target.value.toLowerCase();
    this.links = this.shopItems.filter(x => x.ShopItemName.toLowerCase().includes(searchText)).map(this.getLinkItems);
  }
}
